import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NotificationModule } from "src/app/modules/notification/notification.module";
import { NotifierService } from "src/app/modules/notifier/notifier.service";

@NgModule({
  declarations: [],
  imports: [CommonModule, NotificationModule],
  providers: [NotifierService],
  exports: [NotificationModule],
})
export class NotifierModule {}
